// extracted by mini-css-extract-plugin
export default {"sendInquiryCTA":"_3Kpn9LeTEFM2R2drcNEzie","sendInquiryCTAFull":"_5pCvYBd60ojoyQIHEqx8Zu"};